export default __webpack_public_path__ + "static/media/jeongyeon3.0d28deb3.jpg";